import React from 'react';

import { SPACES } from '@lumapps/communities/keys';
import { spacesAdminRoute } from '@lumapps/community-admin/routes';
import { SideNavigationItem, type SideNavigationItemProps } from '@lumapps/lumx-back-office/components/SideNavigation';
import { mdiCubeUnfolded } from '@lumapps/lumx/icons';
import { useTranslate } from '@lumapps/translations';

interface SpacesSideNavigationProps extends Partial<SideNavigationItemProps> {
    isAllowed: boolean;
}

export const SpacesSideNavigation: React.FC<SpacesSideNavigationProps> = ({ isAllowed, ...restOfProps }) => {
    const { translateKey } = useTranslate();

    if (!isAllowed) {
        return null;
    }

    return (
        <SideNavigationItem
            {...restOfProps}
            label={translateKey(SPACES.NAV)}
            icon={mdiCubeUnfolded}
            route={spacesAdminRoute}
            id="spaces"
        />
    );
};
